import { API, ENV_TYPE } from '../env';
import { ACTIONBASEINFO } from '../actionTypes';
import { readCookie, createCookie, getQueryString, isWeixin, isWeixinWork } from './common';

const JWEIXIN_SCRIPT = '//res.wx.qq.com/open/js/jweixin-1.6.0.js';
const MINIPROGRAM_APPID = 'wx39e5227247bf6815';
const SERVICEACCOUNT_APPID = API.APPID;
const HOST = API.COMMON_PORXY === '/LOCALAPI' ? '//api-fat.vphotos.cn' : API.COMMON_PORXY;
const AUTH_WECHAT_API = `${HOST}/vphotosgallery/wechat/album/authWechat`;
const BASE_SCOPE = 'snsapi_base';
const INFO_SCOPE = 'snsapi_userinfo';

async function loadWeixinScript() {
	let script = document.createElement('script');
	script.src = JWEIXIN_SCRIPT;
	let firstScript = document.getElementsByTagName('script')[0];
	firstScript.parentNode.insertBefore(script, firstScript);
}
function getWeixinConfig(payload, callback, errorCallback) {
	return {
		type: ACTIONBASEINFO.FETCH_BASEINFO_WEIXINCONFIG,
		payload,
		callback,
		errorCallback
	};
}
function configWeixin(weixinCfgData, config) {
	if (process.env.NODE_ENV !== 'development' && (isWeixin() || isWeixinWork())) {
		let wx = window['wx'];
		if (!wx) {
			console.log('wait 1 ...');
			return;
		}
		let { timestamp, nonceStr, signature } = weixinCfgData;
		wx.config({
			debug: getQueryString('wxdebug') ? true : false,
			appId: SERVICEACCOUNT_APPID,
			timestamp,
			nonceStr,
			signature,
			jsApiList: [
				'onMenuShareTimeline',
				'onMenuShareAppMessage',
				'onMenuShareQQ',
				'onMenuShareWeibo',
				'hideOptionMenu',
				'showOptionMenu',
				'hideMenuItems',
				'showMenuItems',
				'hideAllNonBaseMenuItem'
			]
		});
		wx.ready(() => {
			shareConfig(config);
			console.log('wx config ready!');
			window.wx = wx;
		});
		wx.error(() => {
			console.log('wx config error!');
		});
	}
}

function closeWindow() {
	window.wx.closeWindow();
}

function pageLink(toPage, subPath = '') {
	let url = window.location.href;
	let index = url.indexOf('copyright/');
	let size = 'copyright/'.length;
	return url.slice(0, index + size) + toPage + subPath;
}
function shareConfig(config) {
	let wx = window['wx'];
	if (!wx) {
		console.log('wait 2 ...');
		return;
	}
	let { title, desc, link, imgUrl, toPage, subPath } = config;
	if (!imgUrl) {
		imgUrl = 'https://gallerytemplate.vphotos.cn/Test/toutu-logo.jpg';
	}
	if (toPage) {
		link = pageLink(toPage, subPath);
	}
	wx.onMenuShareAppMessage({
		title, // 分享标题
		desc, // 分享描述
		link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
		imgUrl, // 分享图标
		success: function() {
			console.log('设置成功');
		}
	});

	wx.onMenuShareTimeline({
		title, // 分享标题
		link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
		imgUrl, // 分享图标
		success: function() {
			console.log('设置成功');
		}
	});
}

function shouldWeixinAuth() {
	let weixintoken = readCookie('weixintoken');
	// alert('weixintoken', weixintoken)
	let noWeixintoken = false;
	if (!weixintoken || weixintoken === 'null') {
		noWeixintoken = true;
	}
	return process.env.NODE_ENV !== 'development' && (isWeixin() || isWeixinWork()) && noWeixintoken;
}

async function fetchToken(fd) {
	let res = await fetch(AUTH_WECHAT_API, {
		method: 'POST',
		body: fd
	});
	let json = await res.json();
	if (json.code === 0) {
		createCookie('weixintoken', json.data.token, 180);
	}
}
// 把 形如 https://gallery-fat.vphotos.cn/vpmobile/copyright/login?code=021ZL89F0mRt1f2plt6F0cyR8F0ZL89O&state=STATE&other=123 的 url 变成 https://gallery-fat.vphotos.cn/vpmobile/copyright/login?&other=123
function removeAuthParams() {
	let { search, hash } = window.location;
	let reg = /(&?code=[^&]+&state=[^&#]+)/;
	let matches = search.match(reg);
	if (matches && matches[1]) {
		search = search.replace(matches[1], '');
	}
	window.history.replaceState({}, '', `${search}${hash}`);
}
function weixinAuth(options = {}) {
	let { scopeType } = options;
	let typeCode = scopeType === INFO_SCOPE ? 1 : 0;
	let code = getQueryString('code');
	if (code) {
		let fd = new FormData();
		fd.append('authType', typeCode);
		fd.append('code', code);
		fetchToken(fd);
		removeAuthParams();
		return true;
	}
	toWxAuth({ appid: SERVICEACCOUNT_APPID, scopeType });
}

// token 失效时重新授权
function reAuth({ toPage, scopeType }) {
	let options = {
		appid: SERVICEACCOUNT_APPID
	};
	options.scopeType = scopeType || BASE_SCOPE;
	if (toPage) {
		options = { ...options, redirectUrl: pageLink(toPage) };
	}
	console.log(options);
	// alert(JSON.stringify(options));
	toWxAuth(options);
}

function refuseNoAuth() {
	setTimeout(() => {
		let weixintoken = readCookie('weixintoken');
		let code = getQueryString('code');
		let bHasToken = weixintoken && weixintoken !== 'null';
		let bHasCode = code && code !== 'null';
		if (!bHasToken && !bHasCode) {
			window.history.go(-1);
		}
	}, 500);
}

function handleAuthOptions(options = {}) {
	let { scopeType, redirectUrl, state, appid } = options;

	options.scopeType = scopeType || BASE_SCOPE;

	if (!redirectUrl) {
		redirectUrl = window.location.href;
	}
	options.redirectUrl = encodeURIComponent(redirectUrl);

	if (!state) {
		options.state = 'STATE';
	}

	if (!appid) {
		console.error('Weixin Auth without appid !');
		return;
	}

	return options;
}
/**
 * 默认静默授权  只能拿到code 跟 state参数
 * 如果参数为scopeType=snsapi_userinfo 非静默授权
 * 非静默授权 access_token expires_in refresh_token openid scope
 * 参考文档: https://blog.csdn.net/qq_35430000/article/details/79299529
 */
function toWxAuth(options = {}) {
	let { scopeType, redirectUrl, state, appid } = handleAuthOptions(options);
	let authUrl =
		`https://open.weixin.qq.com/connect/oauth2/authorize` +
		`?appid=${appid}` +
		`&redirect_uri=${redirectUrl}` +
		`&response_type=code` +
		`&scope=${scopeType}` +
		`&state=${state}` +
		`&connect_redirect=1` +
		`#wechat_redirect`;
	console.log('authUrl', authUrl);
	// alert(authUrl);
	window.location.replace(authUrl);
	refuseNoAuth();
}
function browserToWxAuth(options = {}) {
	let { scopeType, redirectUrl, state, appid } = handleAuthOptions(options);
	let authUrl =
		`https://open.weixin.qq.com/sns/explorer_broker` +
		`?appid=${appid}` +
		`&redirect_uri=${redirectUrl}` +
		`&response_type=code` +
		`&scope=${scopeType}` +
		`&state=${state}` +
		`&connect_redirect=1` +
		`#wechat_redirect`;
	console.log('authUrl', authUrl);
	// alert(authUrl);
	window.location.replace(authUrl);
	refuseNoAuth();
}
function getWeixinToken(payload, callback, errorCallback) {
	return {
		type: ACTIONBASEINFO.FETCH_BASEINFO_WECHATTOKEN,
		payload,
		callback,
		errorCallback
	};
}
export { loadWeixinScript, getWeixinConfig, configWeixin, MINIPROGRAM_APPID, shareConfig, getWeixinToken, weixinAuth, shouldWeixinAuth, reAuth, closeWindow, toWxAuth, browserToWxAuth };
